<template>
  <app-base-main no-padding parent-table>
    <template #filter-group>
      <app-filter-group
          :reset="false"
          :query="false">
        <gj-select
            v-model="filter.warnTypeCodeList"
            :options="warningTypeList"
            placeholder="预警类型"
            type="multi-check"
            width="150px"
            @change="changeType"
            @input="$gjNoticeQuery"
        ></gj-select>
        <gj-select
            v-model="filter.warnTitleCodeList"
            :options="warningTitleList"
            placeholder="预警标题"
            type="multi-check"
            width="150px"
            @input="$gjNoticeQuery"
        ></gj-select>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          :index="false"
          show-overflow
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          adapt-parent
          @page-change="$gjNoticeQuery">
        <template v-slot:markPro="{row}">
          <gj-switch :disabled="!row.warnStatus" @change="updateMessage(row, 'MSG_WARN_SWITCH_001','markPro')"
                     v-model="row.markPro"></gj-switch>
        </template>

        <template v-slot:markWx="{row}">
          <gj-switch :disabled="!row.warnStatus" @change="updateMessage(row, 'MSG_WARN_SWITCH_002','markWx')"
                     v-model="row.markWx"></gj-switch>
        </template>

        <template v-slot:markApp="{row}">
          <gj-switch :disabled="!row.warnStatus" @change="updateMessage(row, 'MSG_WARN_SWITCH_003','markApp')"
                     v-model="row.markApp"></gj-switch>
        </template>

        <template v-slot:warnStatus="{row}">
          {{ row.warnStatus ? '启用' : '停用' }}
        </template>

        <template v-slot:msgContentStyle="{row}">
          <gj-tooltip :content="row.msgContentStyle">
            <div class="text-ellipsis-1">{{ row.msgContentStyle }}</div>
          </gj-tooltip>
        </template>

        <template v-slot:op="{row}">
          <gj-button-group
              type="dropdown-op"
              :showLength="3"
              :config="opBtnConfig(row)"
          ></gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import AppWarningLogModal from './modal/warning-log-modal'
import AppWarningEditModal from './modal/warning-edit-modal'
import {queryMixin} from "@/minxins";
import {WARNING_TYPE, WARNING_TITLE} from "@/utils/condition";
import {getPollingStatus, getWarningDefaultList, warningSwitch} from "@/api/warning";
import {isMeaningful} from "@/utils/common";
import {USER_GET_POLLING} from "@/store/action-types";

export default {
  name: "warning-config",
  // eslint-disable-next-line vue/no-unused-components
  components: {AppWarningLogModal, AppWarningEditModal},
  mixins: [queryMixin],

  data() {
    return {
      filter: {
        warnTitleCodeList: [],
        warnTypeCodeList: []
      },
      //消息类型下拉框
      warningTypeList: WARNING_TYPE,
      //  消息标题下拉框
      warningTitleList: [...WARNING_TITLE],
      columns: [
        {id: 'warnTypeName', header: '消息类型', field: 'warnTypeName', minWidth: '100px'},
        {id: 'warnTitleName', header: '消息标题', field: 'warnTitleName', minWidth: '140px'},
        {id: 'msgContentStyle', header: '消息内容预览', field: 'slot:msgContentStyle', minWidth: '200px'},
        {id: 'markPro', header: '站内', field: 'slot:markPro', width: '120px'},
        {id: 'markWx', header: '公众号', field: 'slot:markWx', width: '120px'},
        {id: 'markApp', header: 'APP', field: 'slot:markApp', width: '120px'},
        {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '160px'},
        {id: 'updateUserName', header: '更新人', field: 'updateUserName', minWidth: '150px'},
        {id: 'warnStatus', header: '状态', field: 'slot:warnStatus', width: '120px'},
        {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true}],

      opBtnConfig: (row) => [
        {
          label: '编辑',
          show: () => !row.warnStatus,
          click: () => this.openEdit(row)
        },
        {
          label: '启用',
          show: () => !row.warnStatus,
          click: () => this.enable(row)
        },
        {
          label: '停用',
          show: () => row.warnStatus,
          click: () => this.pause(row)
        },
        {
          label: '日志',
          click: () => this.openLog(row)
        },
      ],
      tableData: [],
      // debounceUpdate: this._.debounce(this.updateMessage, 500),
      //  操作当前id
      currentId: null
    }
  },

  methods: {
    // 搜索
    async $gjQuery() {
      const params = {
        model: {...this.filter},
        ...this.queryPagination
      }
      this.loading = true;
      try {
        const {data} = await getWarningDefaultList(params);
        this.tableData = data.records;
        this.pagination = this.getPagination(data);
      } finally {
        this.loading = false
      }
    },

    //  查看日志
    openLog(row) {
      this.$gjCreate(AppWarningLogModal, {
        props: {
          tplId: row.id,
          tplName: row.warnTitleName
        }
      });
    },

    // 编辑预警信息
    openEdit(row) {
      this.$gjCreate(AppWarningEditModal, {
        props: {
          tplId: row.id,
          // tplName: row.warnTitleName,
          // 预警范围
          msgExplainRange: row.msgExplainRange,
          // 频率
          msgExplainRate: row.msgExplainRate,
          // 内容样式
          msgContentStyle: row.msgContentStyle,
        //  使用说明
          msgContentTemplate: row.msgContentTemplate,
          // 消息类型
          warnTypeCode: row.warnTypeCode
        }, on: {
          updated: async (status) => {
            this.$gjQuery();
            const {data} = await getPollingStatus();
          }
        },
      });
    },

    //  启用
    enable(row) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: "启用确认",
          content: `是否确认开启？`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            this.publicSwitch('MSG_WARN_SWITCH_004', true, row.id, modal);
          }
        }
      });
    },

    //  停用
    pause(row) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: "停用确认",
          content: `停用之后，此预警消息将不会生成通知，请确认是否停用？`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            this.publicSwitch('MSG_WARN_SWITCH_004', false, row.id, modal);
          }
        }
      });
    },

    // 操作是否开启关闭预警接口接口
    async publicSwitch(code, value, id, modal) {
      modal.confirmLoading = true;
      const params = {
        id,
        switchCode: code,
        switchVal: value
      }

      try {
        const {data} = await warningSwitch(params);
        if (data) {
          this.$gjMessage.success('操作成功');
          this.$gjResetPage();
          modal.$gjDestroy();

          // 操作成功的话就调用是否开启轮询的接口
          await this.$store.dispatch(USER_GET_POLLING);
        } else {
          this.$gjMessage.success('操作失败');
        }
      } finally {
        modal.confirmLoading = false;
      }
    },

    // 当其中一个数据状态变化时，当失败时，回到原来值
    async updateMessage(row, value, key) {
      const params = {
        id: row.id,
        switchCode: value,
        switchVal: row[key]
      }

      try {
        await warningSwitch(params);
        this.$gjMessage.success('操作成功');

        if(value === 'MSG_WARN_SWITCH_001'){
          // 如果操作的是站内是否开启的话就调用是否开启轮询的接口
          await this.$store.dispatch(USER_GET_POLLING);
        }
        // 成功的情况下可以不去刷新列表了
        // this.$gjResetPage();
      } catch (e) {
        row[key] = !row[key];
      }
    },

    //  修改预警类型
    changeType(value) {
      // 通过‘_’切割并合并判断标题和表单的关联，也要考虑反选时的状态
      this.warningTitleList = WARNING_TITLE.filter(item => {
        let arr = item.id.split('_');
        arr.splice(arr.length - 1, 1);
        return value.indexOf(arr.join('_')) !== -1 || value.length === 0
      })

      this.filter.warnTitleCodeList = [];
      this.$gjNoticeQuery();
    }
  }
}
</script>

<style scoped lang="scss">
</style>
